import { render, staticRenderFns } from "./recipientsRecords.vue?vue&type=template&id=711b3160&"
import script from "./recipientsRecords.vue?vue&type=script&lang=js&"
export * from "./recipientsRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('711b3160')) {
      api.createRecord('711b3160', component.options)
    } else {
      api.reload('711b3160', component.options)
    }
    module.hot.accept("./recipientsRecords.vue?vue&type=template&id=711b3160&", function () {
      api.rerender('711b3160', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/invoiceNo/recipientsRecords.vue"
export default component.exports